import { createFileRoute } from "@tanstack/react-router"
import { useFlags } from "~/features/feature-flags"
import NotFound from "~/components/reusable/NotFound"
import { BudgetForecastComparisonGraphCard } from "~/components/budget/BudgetForecastComparisonGraphCard"
import { BudgetVariantTable } from "~/components/budget/BudgetVariantTable"
import { AnalysisPage } from "~/components/design-system/pages"
import ViewConfiguration from "~/components/planning/ViewConfiguration"
import { BUDGET_REPORT_VARIANT_TABLE_ID } from "~/constants"

export const Route = createFileRoute(
  "/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/target-report",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { budgetVariantLevel, budgetUnreleased } = useFlags()

  if (!budgetUnreleased) return <NotFound />

  return (
    <AnalysisPage
      fillContent
      viewConfiguration={
        <ViewConfiguration tableId={BUDGET_REPORT_VARIANT_TABLE_ID} showWarehouseSelect={false} />
      }
    >
      <BudgetForecastComparisonGraphCard />
      {budgetVariantLevel && <BudgetVariantTable />}
    </AnalysisPage>
  )
}
